export class CPPLandingFilterVM {
  productName: string;
  itemNo: string;
  accountName: string;
  account: string;
  fromRequestedDeliveryDate: any;
  toRequestedDeliveryDate: any;
  fromOrderDate: any;
  toOrderDate: any;
  winfieldReferenceNumber: string;
  webOrderNumber: string;
  customerPONumber: string;
  processingStatus: string;

  quoteNumber: string;
  fromQuoteDate: any;
  toQuoteDate: any;
  fromCloseDate: any;
  toCloseDate: any;
  status: string;

  blanketOrderStatus: string;
  blanketOrderNumber: string;
  fromBlanketOrderDate: any;
  toBlanketOrderDate: any;
  gridType?: string;
}
